/* eslint-disable */
import { Col, Input, message, Row } from 'antd';
import FeatherIcon from 'feather-icons-react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { headerSearchAction } from '../../redux/headerSearch/actionCreator';
import actions from '../../redux/headerSearch/actions';
import { Popover } from '../popup/popup';
import { Div } from './header-search-style';

const HeaderSearch = ({ darkMode }) => {
  const dispatch = useDispatch();
  const { addSelectedUser } = actions;

  const { filteredData } = useSelector((state) => state.headerSearchData);

  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    dispatch(headerSearchAction(searchQuery));
  };

  const handleSelect = (user) => {
    if (!user) return;

    dispatch(addSelectedUser(user));

    const formatName = (name) => name?.toLowerCase().split(' ').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    const displayName = formatName(user.company_name) || formatName(user.name) || 'User';

    message.success(`User ${displayName} has been successfully selected.`);
  };

  const content = (
    <div>
      {filteredData.length ? (
        filteredData.map((user) => {
          const { _id, email, name } = user;
          return (
            <div
              key={_id}
              style={{
                cursor: 'pointer',
                padding: '8px',
                borderBottom: '1px solid #f0f0f0',
              }}
              onClick={() => handleSelect(user)}
            >
              <span>{name}</span> - <span>{email}</span>
            </div>
          );
        })
      ) : (
        <div>No matching results...</div>
      )}
    </div>
  );

  return (
    <Div className="certain-category-search-wrapper" style={{ width: '100%' }} darkMode={darkMode}>
      <Row className="ant-row-middle">
        <Col md={2} xs={1}>
          <span className="certain-category-icon">
            <FeatherIcon icon="search" size={16} />
          </span>
        </Col>
        <Col md={22} xs={23}>
          <Popover placement="bottomLeft" content={content} title="Search Results" trigger="focus">
            <Input style={{ height: '36px' }} placeholder="Search by email..." onInput={handleSearch} />
          </Popover>
        </Col>
      </Row>
    </Div>
  );
};

HeaderSearch.propTypes = {
  darkMode: PropTypes.bool,
};

export default HeaderSearch;
